<template>
  <SlideOutContainerViaPortal :disableAnimation="disableAnimation" :loading="internalLoading">
    <div
      class="container-fluid"
      :style="inModal ? 'z-index: 501; overflow: scroll' : ''"
      style="padding-top: 17px;"
      v-if="show"
    >
    <!-- we need below  <div>p</div> to have proper layout on UI. Remove it when have oportunity to check and fix the layout without the element-->
    <div>p</div>
      <InvoiceEditLayout :isSecondaryLayout="!isDocumentPreviewPanelVisible">
        <template #left-column>
          <PageHeader showBreadcrumbs :customBreadcrumbs="breadcrumbs" :page-title="headerTitle" wrapperClassName="row">
            <template #onSideOfTitle>
              <div class="d-flex align-items-center gap-1">
                <PayoutStatus :status="data && data.invoice_status" />
                <span
                  v-if="data && isInvoiceOverdue(data)"
                  class="material-symbols-outlined ms-2 text-danger"
                  style="font-size: 20px;"
                  v-b-tooltip.hover="{
                    title: `This invoice is overdue by ${getOverdueDays(data)} days.<br>Due date: ${formatDate(data.due_date)}`,
                    variant: 'base',
                    container: 'body',
                    placement: 'top',
                    boundary: 'viewport',
                    html: true,
                    delay: 300
                  }"
                >
                  event_busy
                </span>
              </div>
            </template>
          </PageHeader>

          <b-form class="form-generator row" ref="invoiceForm" @submit.prevent="submit">
            <InvoiceFormCard>
              <PanelHeader :title="title" :isOpen="blocksShow.main" :onToggleButtonClick="toggleMainBlock" />
              <b-collapse v-model="blocksShow.main">
                <b-card-body class="pt-0">
                  <b-form-group>
                    <label class="form__label">{{form.fields.project.label}}</label>
                    <div v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }" :title="form.fields.project.value ? form.fields.project.value[form.fields.project.selectLabel] : null">
                      <multiselect
                        v-model="$v.form.fields.project.value.$model"
                        :options="form.fields.project.options"
                        :track-by="form.fields.project.valueField"
                        :label="form.fields.project.selectLabel"
                        :showLabels="false"
                        :class="{ 'multiselect__single-line': true, 'is-invalid': (formSubmissionAttempted && ($v.form.fields.project.value.$error || $v.form.fields.project.value.$invalid)) || getBackendError('project_id'), 'is-valid': shouldShowGreenBorder('project') }"
                        allow-empty
                        @select="(value) => { changeProject(value); clearBackendError('project_id'); }"
                      />
                    </div>
                    <FieldErrorMessage
                      :backend-error="getBackendError('project_id')"
                      :show-frontend-error="formSubmissionAttempted && $v.form.fields.project.value.$error"
                      frontend-message="Field is required"
                    />
                  </b-form-group>
                  <div class="row">
                    <b-form-group class="col-6">
                      <label class="form__label">{{form.fields.own_bank_details.label}}</label>
                      <div v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }" :title="form.fields.own_bank_details.value ? form.fields.own_bank_details.value[form.fields.own_bank_details.selectLabel] : null">
                        <multiselect
                          :class="{ 'multiselect__single-line': true, 'is-invalid': (formSubmissionAttempted && ($v.form.fields.own_bank_details.value.$error || $v.form.fields.own_bank_details.value.$invalid)) || getBackendError('own_bank_details_id'), 'is-valid': shouldShowGreenBorder('own_bank_details') }"
                          v-model="$v.form.fields.own_bank_details.value.$model"
                          :options="form.fields.own_bank_details.options"
                          :placeholder="form.fields.own_bank_details.placeholder"
                          :track-by="form.fields.own_bank_details.valueField"
                          :label="form.fields.own_bank_details.selectLabel"
                          :allow-empty="false"
                          :showLabels="false"
                          @select="(value) => { cachePreview(); clearBackendError('own_bank_details_id'); }"
                        />
                      </div>
                      <FieldErrorMessage
                        :backend-error="getBackendError('own_bank_details_id')"
                        :show-frontend-error="formSubmissionAttempted && $v.form.fields.own_bank_details.value.$error"
                        frontend-message="Field is required"
                      />
                    </b-form-group>
                    <b-form-group class="col-6">
                      <label class="form__label">{{form.fields.client_bank_details.label}}
                        <span @click="refreshClientBanks()" class="ml-1" title="Refresh">
                          <font-awesome-icon icon="sync-alt" role="button"/>
                          <span v-if="isFetchingBankDetails"
                                class="small-spinner spinner-border text-secondary fetch-bank-details-spinner"
                                role="status">
                            <span class="sr-only">Loading...</span>
                          </span>
                        </span>
                      </label>
                      <div v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }" :title="form.fields.client_bank_details.value ? form.fields.client_bank_details.value[form.fields.client_bank_details.selectLabel] : null">
                        <multiselect
                          :class="{ 'multiselect__single-line': true, 'is-invalid': (formSubmissionAttempted && ($v.form.fields.client_bank_details.value.$error || $v.form.fields.client_bank_details.value.$invalid)) || getBackendError('client_bank_details_id'), 'is-valid': shouldShowGreenBorder('client_bank_details') }"
                          v-model="$v.form.fields.client_bank_details.value.$model"
                          :options="form.fields.client_bank_details.options"
                          :placeholder="form.fields.client_bank_details.placeholder"
                          :track-by="form.fields.client_bank_details.valueField"
                          :label="form.fields.client_bank_details.selectLabel"
                          :allow-empty="false"
                          :showLabels="false"
                          @select="(value) => { cachePreview(); clearBackendError('client_bank_details_id'); }"
                        />
                      </div>
                      <FieldErrorMessage
                        :backend-error="getBackendError('client_bank_details_id')"
                        :show-frontend-error="formSubmissionAttempted && $v.form.fields.client_bank_details.value.$error"
                        frontend-message="Field is required"
                      />
                    </b-form-group>
                  </div>
                  <div class="row">
                    <b-form-group class="col-4">
                      <label class="form__label">{{form.fields.invoice_status.label}}</label>
                      <div v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }" :title="form.fields.invoice_status.value ? form.fields.invoice_status.value[form.fields.invoice_status.selectLabel] : null">
                        <multiselect
                          v-model="$v.form.fields.invoice_status.value.$model"
                          :options="form.fields.invoice_status.options"
                          :placeholder="form.fields.invoice_status.placeholder"
                          :track-by="form.fields.invoice_status.valueField"
                          :label="form.fields.invoice_status.selectLabel"
                          :class="{ 'multiselect__single-line': true, 'is-invalid': getBackendError('invoice_status_id') }"
                          :allow-empty="false"
                          :showLabels="false"
                          @select="clearBackendError('invoice_status_id')"
                        />
                      </div>
                      <FieldErrorMessage
                        :backend-error="getBackendError('invoice_status_id')"
                      />
                    </b-form-group>
                    <b-form-group class="col-4">
                      <label class="form__label">{{form.fields.invoice_template_type.label}}</label>
                      <div v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }" :title="form.fields.invoice_template_type.value ? form.fields.invoice_template_type.value[form.fields.invoice_template_type.selectLabel] : null">
                        <multiselect
                          :id="invoiceTemplateTypeFieldId"
                          v-model="$v.form.fields.invoice_template_type.value.$model"
                          :options="form.fields.invoice_template_type.options"
                          :placeholder="form.fields.invoice_template_type.placeholder"
                          :track-by="form.fields.invoice_template_type.valueField"
                          :label="form.fields.invoice_template_type.selectLabel"
                          :class="{ 'multiselect__single-line': true, 'is-invalid': getBackendError('invoice_template_type_id') }"
                          :allow-empty="false"
                          :showLabels="false"
                          @select="(value) => { cachePreview(); clearBackendError('invoice_template_type_id'); }"
                        />
                      </div>
                      <FieldErrorMessage
                        :backend-error="getBackendError('invoice_template_type_id')"
                      />
                    </b-form-group>
                    <b-form-group class="col-4" v-if="!form.fields.custom_file.hidden">
                      <label class="form__label">{{ form.fields.custom_file.label }}</label>
                      <div class="row">
                        <div class="col">
                          <CustomFile
                            ref="customFile"
                            v-model="$v.form.fields.custom_file.value.$model"
                            :placeholder="data && data.custom_file_name"
                            :accept="customFilesAcceptedTypes"
                          />
                        </div>
                      </div>
                    </b-form-group>
                  </div>
                  <div class="row">
                    <b-form-group class="col-12">
                      <label class="form__label">{{form.fields.comment.label}}</label>
                      <b-form-input
                        :class="{ 'is-invalid': (formSubmissionAttempted && ($v.form.fields.comment.value.$error || $v.form.fields.comment.value.$invalid)) || getBackendError('comment'), 'is-valid': shouldShowGreenBorder('comment') }"
                        type="text"
                        v-model="$v.form.fields.comment.value.$model"
                        :placeholder="form.fields.comment.placeholder"
                        debounce="300"
                        @keydown="keyDown"
                        @input="(value) => { cachePreview(); clearBackendError('comment'); }"
                      />
                      <FieldErrorMessage
                        :backend-error="getBackendError('comment')"
                        :show-frontend-error="formSubmissionAttempted && $v.form.fields.comment.value.$error"
                        frontend-message="Field is required"
                      />
                    </b-form-group>
                  </div>
                  <div class="row">
                    <b-form-group class="col-4">
                      <label class="form__label">{{form.fields.issue_date.label}}</label>
                      <Datepicker
                        :bootstrap-styling="true"
                        :value="_toIsoStringTime(form.fields.issue_date.value)"
                        @input="$v.form.fields.issue_date.value.$model = _toLocalTime($event); cachePreview(); clearRelatedDateErrors('issue_date')"
                        :disabledDates="form.fields.issue_date.disabledDates"
                        :placeholder="form.fields.issue_date.placeholder"
                        :format="form.fields.issue_date.format"
                        :minimum-view="form.fields.issue_date.minimumView"
                        :disabled="form.fields.issue_date.disabled"
                        :class="{ 'is-invalid': getBackendError('issue_date'), 'is-valid': shouldShowGreenBorder('issue_date') }"
                        class="datapicker"
                      />
                      <FieldErrorMessage
                        :backend-error="getBackendError('issue_date')"
                      />
                    </b-form-group>
                    <b-form-group class="col-4">
                      <label class="form__label">{{form.fields.due_date.label}}</label>
                      <Datepicker
                        :bootstrap-styling="true"
                        :value="_toIsoStringTime(form.fields.due_date.value)"
                        @input="$v.form.fields.due_date.value.$model = _toLocalTime($event); cachePreview(); clearRelatedDateErrors('due_date')"
                        :disabledDates="form.fields.due_date.disabledDates"
                        :placeholder="form.fields.due_date.placeholder"
                        :format="form.fields.due_date.format"
                        :minimum-view="form.fields.due_date.minimumView"
                        :disabled="form.fields.due_date.disabled"
                        :class="{ 'is-invalid': getBackendError('due_date'), 'is-valid': shouldShowGreenBorder('due_date') }"
                        class="datapicker"
                      />
                      <FieldErrorMessage
                        :backend-error="getBackendError('due_date')"
                      />
                    </b-form-group>
                    <b-form-group class="col-4" v-if="!form.fields.paid_date.hidden">
                      <label class="form__label">{{form.fields.paid_date.label}}</label>
                      <Datepicker
                        :bootstrap-styling="true"
                        :value="_toIsoStringTime(form.fields.paid_date.value)"
                        @input="$v.form.fields.paid_date.value.$model = _toLocalTime($event); cachePreview(); clearBackendError('paid_date')"
                        :disabledDates="form.fields.paid_date.disabledDates"
                        :placeholder="form.fields.paid_date.placeholder"
                        :format="form.fields.paid_date.format"
                        :minimum-view="form.fields.paid_date.minimumView"
                        :disabled="form.fields.paid_date.disabled"
                        :class="{ 'is-invalid': getBackendError('paid_date'), 'is-valid': shouldShowGreenBorder('paid_date') }"
                        class="datapicker"
                      />
                      <FieldErrorMessage
                        :backend-error="getBackendError('paid_date')"
                      />
                    </b-form-group>
                  </div>
                </b-card-body>
              </b-collapse>
            </InvoiceFormCard>

            <InvoiceFormCard>
              <PanelHeader title="Items" :isOpen="blocksShow.items" :onToggleButtonClick="toggleItemsBlock" />
              <b-collapse v-model="blocksShow.items">
                <b-card-body class="pt-0 pb-0">
                  <b-form-group>
                    <label class="form__label">{{form.fields.invoice_type.label}}</label>
                    <div v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }" :title="form.fields.invoice_type.value ? form.fields.invoice_type.value[form.fields.invoice_type.selectLabel] : null">
                      <multiselect
                        v-model="$v.form.fields.invoice_type.value.$model"
                        :options="form.fields.invoice_type.options"
                        :placeholder="form.fields.invoice_type.placeholder"
                        :track-by="form.fields.invoice_type.valueField"
                        :label="form.fields.invoice_type.selectLabel"
                        :class="{ 'multiselect__single-line': true, 'is-invalid': getBackendError('invoice_type_id') }"
                        :allow-empty="false"
                        :showLabels="false"
                        @select="clearBackendError('invoice_type_id')"
                      />
                    </div>
                    <FieldErrorMessage
                      :backend-error="getBackendError('invoice_type_id')"
                    />
                  </b-form-group>
                  <b-form-group v-if="form.fields.auto_fill.value.date_from || form.fields.auto_fill.value.date_to">
                    <div class="row form-generator__items">
                      <div class="col col-md-4">
                        <label class="form__label">Date from:</label>
                        <Datepicker
                          :bootstrap-styling="true"
                          v-model="$v.form.fields.auto_fill.value.date_from.$model"
                          format="yyyy-MM-dd"
                          :use-utc="true"
                        />
                      </div>
                      <div class="col col-md-4">
                        <label class="form__label">Date to:</label>
                        <Datepicker
                          :bootstrap-styling="true"
                          v-model="$v.form.fields.auto_fill.value.date_to.$model"
                          format="yyyy-MM-dd"
                          :use-utc="true"
                        />
                      </div>
                      <div class="col col-md-4">
                        <label class="form__label">&nbsp;</label>
                        <b-button
                          type="submit"
                          class="button w-100 justify-content-center"
                          variant="primary"
                          @click.prevent="handleAutoFillButtonClick">
                          Auto Fill Items
                        </b-button>
                      </div>
                    </div>
                  </b-form-group>
                  <div class="row mb-3">
                    <b-form-group v-if="form.fields.invoice_type.value && form.fields.invoice_type.value.id === 3 || form.fields.invoice_type.value && form.fields.invoice_type.value.id === 4" class="col col-4">
                      <label class="form__label">{{form.fields.commission.label}}</label>
                      <b-form-input
                        type="number"
                        no-wheel
                        v-model="$v.form.fields.commission.value.$model"
                        :class="{ 'is-invalid': getBackendError('commission') }"
                        @input="dataTouched($event, 'commission'); clearBackendError('commission')"
                      />
                      <FieldErrorMessage
                        :backend-error="getBackendError('commission')"
                      />
                    </b-form-group>
                    <b-form-group v-if="form.fields.invoice_type.value && form.fields.invoice_type.value.id === 3" class="col col-4">
                      <label class="form__label">Sales commission</label>
                      <SalesCommissionSelect
                        :value="form.fields.sales_commission_percent.value"
                        :options="config.salesCommissionOptions"
                        :onChange="(val) => $v.form.fields.sales_commission_percent.value.$model = val" />
                    </b-form-group>
                  </div>
                </b-card-body>
              </b-collapse>

              <PanelDelimiter />

              <FinancesInvoicesCompanyItemsTable
                columnHeaderClass="column-header-class"
                v-if="form.fields.invoice_type.value && isEmployeeTm()"
                v-model="form.fields.items.value"
                :validation="$v.form.fields.items.value"
                :formSubmissionAttempted="formSubmissionAttempted"
                :backendErrors="backendErrors"
                @dataTouched="dataTouched($event, 'items'); $v.form.fields.items.value.$touch();"
                @dataRemoved="dataRemoved($event, 'items'); $v.form.fields.items.value.$touch();"
                @updateBackendErrors="backendErrors = $event"
              />

              <FinancesInvoicesCompanyPeriodsTable
                columnHeaderClass="column-header-class"
                v-if="form.fields.invoice_type.value && isEmployeePeriod()"
                v-model="form.fields.periods.value"
                :validation="$v.form.fields.periods.value"
                :formSubmissionAttempted="formSubmissionAttempted"
                :backendErrors="backendErrors"
                @dataTouched="dataTouched($event, 'periods'); $v.form.fields.periods.value.$touch();"
                @dataRemoved="dataRemoved($event, 'periods'); $v.form.fields.periods.value.$touch();"
                @updateBackendErrors="backendErrors = $event"
              />

              <FinancesInvoicesCompanySpecialisationsTable
                columnHeaderClass="column-header-class"
                v-if="form.fields.invoice_type.value && form.fields.invoice_type.value.id === config.invoiceTypes.project_specialisation.id"
                v-model="form.fields.specialisations.value"
                :validation="$v.form.fields.specialisations.value"
                :formSubmissionAttempted="formSubmissionAttempted"
                :backendErrors="backendErrors"
                @dataTouched="dataTouched($event, 'specialisations'); $v.form.fields.specialisations.value.$touch();"
                @dataRemoved="dataRemoved($event, 'specialisations'); $v.form.fields.specialisations.value.$touch();"
                @updateBackendErrors="backendErrors = $event"
              />

              <FinancesInvoicesExtraPaymentsTable
                v-model="form.fields.extra_payments.value"
                :currencyCode="currency"
                :invoiceType="form.fields.invoice_type.value"
                columnHeaderClass="column-header-class"
                @dataTouched="dataTouched($event, 'extraPayments'); $v.form.fields.extra_payments.value.$touch();"
                @dataRemoved="dataRemoved($event, 'extraPayments'); $v.form.fields.extra_payments.value.$touch();"
              />
            </InvoiceFormCard>
          </b-form>
        </template>
        <template #right-column>
          <PageHeader page-title="Preview PDF" wrapperClassName="d-flex" titleClassName="flex-grow-1" style="margin-bottom: 15px !important;">
            <template #buttons>
              <DocumentButtons>
                <DocumentButtonsGroup v-if="data && data.download_url">
                  <DownloadDocumentLink :href="data.download_url" tooltip="Download Invoice" @download-click="showDownloadModal" ref="downloadButton" />
                  <PreviewDocumentLink :href="data.preview_url" />
                </DocumentButtonsGroup>
                <TogglePreviewButton
                  v-if="isDocumentPreviewAvailable"
                  :value="isDocumentPreviewPanelVisible"
                  @input="toggleDocumentPreview()" />
                <CloseButton tooltip="Close form" :onClick="closeForm" />
              </DocumentButtons>
            </template>
          </PageHeader>

          <CollapsingContainer
            :isOpen="isDocumentPreviewPanelVisible"
            @onOpen="ui.isDocPreviewIframeReadyToBeDisplayed = true"
            @onHidden="ui.isDocPreviewIframeReadyToBeDisplayed = false"
          >
            <DocumentPreview
              :isCustomTemplateTypeSelected="isCustomTemplateTypeSelected"
              :isLastUpdatePreviewRequestFailed="isLastUpdatePreviewRequestFailed"
              :uploadedFileName="uploadedCustomFileName"
              :attachedFileName="attachedCustomFileName"
              :attachedFileChanged="customFileChanged"
            >
              <InvoiceFormCard v-if="isDocumentPreviewAvailable" :noBody="false">
                <DocumentPreviewIFrame
                  :enforceShowLoader="updatePreviewRequestScheduled || !ui.isDocPreviewIframeReadyToBeDisplayed"
                  :url="docPreviewUrl"
                  iframeHeight="calc(100vh - 300px)"
                  :toolbar="false" />
              </InvoiceFormCard>
            </DocumentPreview>
          </CollapsingContainer>

          <InvoiceFormCard>
            <div class="row p-3">
              <div class="col-md-7 d-flex align-items-center">
                <TotalAmount
                  :isLoading="isCalculatingAmount"
                  :value="form.fields.amount.value"
                  :currencyCode="currency" />
              </div>
              <div class="col-md-5">
                <b-button
                  type="submit"
                  @click="submitForm"
                  class="button w-100 justify-content-center"
                  variant="primary">
                  {{ data && data.id ? 'Save' : 'Create' }}
                </b-button>
              </div>
            </div>
          </InvoiceFormCard>
        </template>
      </InvoiceEditLayout>
    </div>
  </SlideOutContainerViaPortal>
</template>

<script>
import Moment from 'moment'
import { cloneDeep, debounce, uniqueId } from 'lodash'
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Datepicker from 'vuejs-datepicker'
import InvoiceFormModal from '@mixins/InvoiceFormModal'
import { DocumentPreviewMixin } from '@mixins/invoices/DocumentPreviewMixin'
import { DocumentPreviewViewMixin } from '@mixins/invoices/DocumentPreviewViewMixin'
import { InvoiceEditConfirmTabCloseMixin } from '@mixins/invoices/InvoiceEditConfirmTabCloseMixin'
import PageHeader from '@components/PageHeader.vue'
import SlideOutContainerViaPortal from '@components/transition/SlideOutContainerViaPortal.vue'
import CollapsingContainer from '@components/transition/CollapsingContainer.vue'
import DocumentPreviewIFrame from '@components/invoices/DocumentPreviewIFrame.vue'
import DocumentPreview from '@components/invoices/DocumentPreview.vue'
import InvoiceEditLayout from '@components/invoices/InvoiceEditLayout.vue'
import PanelHeader from '@components/invoices/form/PanelHeader.vue'
import DocumentButtons from '@components/invoices/form/DocumentButtons.vue'
import DocumentButtonsGroup from '@components/invoices/form/DocumentButtonsGroup.vue'
import DownloadDocumentLink from '@components/invoices/form/DownloadDocumentLink.vue'
import CloseButton from '@components/common/CloseButton.vue'
import InvoiceFormCard from '@components/invoices/form/InvoiceFormCard.vue'
import TogglePreviewButton from '@components/invoices/form/TogglePreviewButton.vue'
import PreviewDocumentLink from '@components/invoices/form/PreviewDocumentLink.vue'
import TotalAmount from '@components/invoices/form/TotalAmount.vue'
import PanelDelimiter from '@components/modals/FinanceInvoicesForm/components/PanelDelimiter.vue'
import SalesCommissionSelect from '@components/modals/FinanceInvoicesForm/components/SalesCommissionSelect.vue'
import FinancesInvoicesCompanyItemsTable from '@tables/FinancesInvoicesCompanyItemsTable.vue'
import FinancesInvoicesCompanyPeriodsTable from '@tables/FinancesInvoicesCompanyPeriodsTable.vue'
import FinancesInvoicesCompanySpecialisationsTable from '@tables/FinancesInvoicesCompanySpecialisationsTable.vue'
import FinancesInvoicesExtraPaymentsTable from '@tables/FinancesInvoicesExtraPaymentsTable.vue'
import CustomFile from '@forms/CustomFile.vue'
import { CUSTOM_FILE_ACCEPTED_TYPES } from '@/constants/invoices'
import PayoutStatus from '@components/tables/elements/PayoutStatus'
import FieldErrorMessage from '@components/forms/FieldErrorMessage.vue'

export default {
  name: 'FinanceInvoicesForm',
  mixins: [
    validationMixin,
    InvoiceFormModal,
    DocumentPreviewMixin({
      updatePreviewCacheUrl: '/api/finances/invoices/cache-preview/'
    }),
    DocumentPreviewViewMixin,
    InvoiceEditConfirmTabCloseMixin
  ],
  components: {
    CustomFile,
    TotalAmount,
    Datepicker,
    FinancesInvoicesCompanyItemsTable,
    FinancesInvoicesCompanyPeriodsTable,
    FinancesInvoicesCompanySpecialisationsTable,
    FinancesInvoicesExtraPaymentsTable,
    InvoiceEditLayout,
    PageHeader,
    DocumentButtons,
    DocumentButtonsGroup,
    DownloadDocumentLink,
    PreviewDocumentLink,
    TogglePreviewButton,
    CloseButton,
    SlideOutContainerViaPortal,
    CollapsingContainer,
    PanelHeader,
    InvoiceFormCard,
    PanelDelimiter,
    SalesCommissionSelect,
    DocumentPreviewIFrame,
    DocumentPreview,
    PayoutStatus,
    FieldErrorMessage
  },
  emits: ['input', 'submit', 'updateItem', 'invoiceFormClosed', 'showDownloadModal', 'loadingChange'],
  props: {
    disableAnimation: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    inModal: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'create'
    },
    title: {
      type: String
    },
    headerTitle: {
      type: String
    },
    submitButtonText: {
      type: String
    },
    bankDetails: {
      type: Array
    },
    templates: {
      type: Array
    },
    projects: {
      type: Array
    },
    statuses: {
      type: Array
    },
    types: {
      type: Array
    },
    data: {
      type: Object
    },
    value: {
      type: Boolean
    },
    zIndex: {
      type: String,
      default: ''
    },
    breadcrumbs: { type: Array, default: () => [] }
  },
  validations () {
    const rules = { form: { fields: {} } }

    for (let key in this.form.fields) {
      rules.form.fields[key] = { value: {} }

      if (this.form.fields[key].validation) {
        if (Array.isArray(this.form.fields[key].validation)) {
          // Handle array format like UserMixin
          for (let validator of this.form.fields[key].validation) {
            if (validator.name === 'required') {
              if (validator.condition) {
                // Conditional required validation
                rules.form.fields[key].value.required = (value) => {
                  if (validator.condition(value, this)) {
                    return !!value && (Array.isArray(value) ? value.length > 0 : true)
                  }
                  return true
                }
              } else {
                // Simple required validation
                rules.form.fields[key].value.required = required
              }
            } else if (validator.name === 'itemsValid') {
              if (validator.condition) {
                rules.form.fields[key].value.itemsValid = (value) => {
                  if (validator.condition(value, this)) {
                    // Check that all items have required fields: user, hours_amount, date_from, date_to
                    return value && value.length > 0 && value.every(item =>
                      item.user !== null &&
                      item.hours_amount &&
                      item.hours_amount > 0 &&
                      item.date_from &&
                      item.date_to
                    )
                  }
                  return true
                }
              }
            } else if (validator.name === 'periodsValid') {
              if (validator.condition) {
                rules.form.fields[key].value.periodsValid = (value) => {
                  if (validator.condition(value, this)) {
                    // Check that all periods have required fields: user, hours_amount, period_cost, date_from, date_to
                    return value && value.length > 0 && value.every(item =>
                      item.user !== null &&
                      item.hours_amount &&
                      item.hours_amount > 0 &&
                      item.period_cost &&
                      item.period_cost > 0 &&
                      item.date_from &&
                      item.date_to
                    )
                  }
                  return true
                }
              }
            } else if (validator.name === 'specialisationsValid') {
              if (validator.condition) {
                rules.form.fields[key].value.specialisationsValid = (value) => {
                  if (validator.condition(value, this)) {
                    // Check that all specialisations have required fields: specialisation_id, hours, cost
                    return value && value.length > 0 && value.every(item =>
                      item.specialisation_id !== null &&
                      item.hours &&
                      item.hours > 0 &&
                      item.cost &&
                      item.cost > 0
                    )
                  }
                  return true
                }
              }
            }
          }
        } else {
          // Handle object format (legacy)
          rules.form.fields[key].value = this.form.fields[key].validation
        }
      } else {
        rules.form.fields[key].value = {} // need to assign an empty object to make sure the field included in the dirty check
      }
    }

    return rules
  },
  data () {
    const defaultProjectName = '%ProjectName%'
    const defaultAutoFillValue = {
      date_from: Moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
      date_to: Moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
    }
    const defaultForm = {
      fields: {
        'id': {
          name: 'id'
        },
        'project': {
          type: 'slot',
          slotName: 'Project',
          name: 'project_id',
          label: 'Project *',
          selectLabel: 'label',
          valueField: 'id',
          options: [],
          value: null,
          validation: [{ name: 'required' }],
          class: 'col-12'
        },
        'own_bank_details': {
          type: 'select',
          name: 'own_bank_details_id',
          label: 'Own bank details *',
          selectLabel: 'summary',
          valueField: 'id',
          options: [],
          value: null,
          touched: false,
          validation: [{ name: 'required' }],
          class: 'col-6'
        },
        'client_bank_details': {
          type: 'slot',
          slotName: 'ClientBankDetails',
          name: 'client_bank_details_id',
          label: 'Client bank details *',
          selectLabel: 'title',
          valueField: 'id',
          options: [],
          value: null,
          validation: [{ name: 'required' }],
          class: 'col-6'
        },
        'invoice_status': {
          type: 'select',
          name: 'invoice_status_id',
          label: 'Invoice status',
          selectLabel: 'display_name',
          valueField: 'id',
          options: [],
          value: null,
          touched: false,
          validation: {
            required
          },
          class: 'col-4'
        },
        'invoice_template_type': {
          type: 'select',
          name: 'invoice_template_type_id',
          label: 'Invoice template type',
          selectLabel: 'name',
          valueField: 'id',
          options: [],
          value: null,
          touched: false,
          validation: [{ name: 'required' }],
          class: 'col-4'
        },
        'custom_file': {
          type: 'slot',
          slotName: 'CustomFile',
          name: 'custom_file',
          label: 'Custom doc file',
          value: null,
          class: 'col-12 col-md-4',
          hidden: true
        },
        'comment': {
          type: 'input',
          name: 'comment',
          label: 'Comment',
          placeholder: 'Comment',
          validation: {
            required
          },
          defaultValue: 'Software development for %ProjectName%',
          value: null
        },
        'comment_national': {
          type: 'input',
          name: 'comment_national',
          label: 'Comment national',
          placeholder: 'Comment National',
          validation: {
            required
          },
          defaultValue: 'Software development for %ProjectName%',
          value: null
        },
        'issue_date': {
          type: 'datepicker',
          name: 'issue_date',
          label: 'Issue date',
          format: 'yyyy-MM-dd',
          placeholder: 'Issue Date',
          class: 'col-4',
          value: Moment().format('YYYY-MM-DD')
        },
        'due_date': {
          type: 'datepicker',
          name: 'due_date',
          label: 'Due date',
          format: 'yyyy-MM-dd',
          placeholder: 'Due Date',
          class: 'col-4',
          value: Moment().add(3, 'days').isSameOrBefore(Moment().endOf('month')) ? Moment().add(3, 'days').format('YYYY-MM-DD') : Moment().endOf('month').format('YYYY-MM-DD')
        },
        'paid_date': {
          type: 'datepicker',
          name: 'paid_date',
          label: 'Paid date',
          format: 'yyyy-MM-dd',
          placeholder: 'Paid Date',
          class: 'col-4',
          defaultValue: Moment().format('YYYY-MM-DD'),
          value: null,
          hidden: false
        },
        'invoice_type': {
          type: 'select',
          name: 'invoice_type_id',
          label: 'Invoice type',
          selectLabel: 'type',
          valueField: 'id',
          options: [],
          value: null,
          touched: false,
          validation: {
            required
          }
        },
        'auto_fill': {
          type: 'slot',
          slotName: 'AutoFill',
          name: 'auto_fill',
          label: 'Auto fill contractors (all items will be replaced)',
          value: cloneDeep(defaultAutoFillValue),
          defaultValue: cloneDeep(defaultAutoFillValue),
          validation: Object.keys(defaultAutoFillValue).reduce((acc, key) => {
            acc[key] = {}
            return acc
          }, {})
        },
        'items': {
          type: 'slot',
          slotName: 'Items',
          name: 'items',
          label: 'Items',
          value: [],
          validation: [{
            name: 'required',
            condition: (value, vm) => {
              if (!vm.form.fields.invoice_type.value) return false
              return vm.form.fields.invoice_type.value.id === 1
            }
          }, {
            name: 'itemsValid',
            condition: (value, vm) => {
              if (!vm.form.fields.invoice_type.value || vm.form.fields.invoice_type.value.id !== 1) return false
              return true
            }
          }]
        },
        'periods': {
          type: 'slot',
          slotName: 'Periods',
          name: 'periods',
          label: 'Periods',
          value: [],
          validation: [{
            name: 'required',
            condition: (value, vm) => {
              if (!vm.form.fields.invoice_type.value) return false
              return vm.form.fields.invoice_type.value.id === 2
            }
          }, {
            name: 'periodsValid',
            condition: (value, vm) => {
              if (!vm.form.fields.invoice_type.value || vm.form.fields.invoice_type.value.id !== 2) return false
              return true
            }
          }]
        },
        'specialisations': {
          type: 'slot',
          slotName: 'Specialisations',
          name: 'specialisations',
          label: 'Project Specialisation',
          value: [],
          validation: [{
            name: 'required',
            condition: (value, vm) => {
              if (!vm.form.fields.invoice_type.value) return false
              return vm.form.fields.invoice_type.value.id === 3
            }
          }, {
            name: 'specialisationsValid',
            condition: (value, vm) => {
              if (!vm.form.fields.invoice_type.value || vm.form.fields.invoice_type.value.id !== 3) return false
              return true
            }
          }]
        },
        'commission': {
          type: 'slot',
          slotName: 'Commission',
          name: 'commission',
          label: 'Commission',
          value: null,
          class: 'col-6'
        },
        'sales_commission_percent': {
          type: 'slot',
          slotName: 'SalesCommission',
          name: 'sales_commission_percent',
          label: 'Sales commission percent',
          value: 0,
          class: 'col-6'
        },
        'extra_payments': {
          type: 'slot',
          slotName: 'ExtraPayments',
          name: 'extra_payments',
          label: 'Extra payments',
          value: []
        },
        'amount': {
          type: 'slot',
          slotName: 'amount',
          name: 'amount',
          label: 'Amount',
          value: 0
        }
      }
    }

    return {
      defaultForm,
      form: cloneDeep(defaultForm),
      blocksShow: {
        main: true,
        items: true,
        employees: true,
        extraPayments: true
      },
      previousInvoiceData: {
        'items': [],
        'periods': []
      },
      currency: 'USD',
      isCalculatingAmount: false,
      calculateTotalCancelToken: null,
      isFetchingBankDetails: false,
      clientsOptions: [],
      currentInvoiceType: 1,
      formSubmissionAttempted: false,
      backendErrors: {},
      fieldsWithPreviousErrors: new Set(), // Track fields that have had validation errors
      internalLoading: false,
      loadingStartTime: null,
      minimumLoadingDuration: 1500, // Minimum 1.5 seconds loading
      isInitializing: false,
      config: {
        invoiceTypes: {
          employee_tm: { id: 1 },
          employee_period: { id: 2 },
          project_specialisation: { id: 3 },
          employee_only_extra_payments: { id: 4 }
        },
        requireRecalculateInvoiceAmount: {
          items: ['hour_cost', 'hours_amount', 'commission'],
          periods: ['period_cost', 'commission'],
          specialisations: ['cost'],
          extraPayments: ['cost'],
          commission: true
        },
        defaultProjectName,
        matchProjectName: defaultProjectName,
        salesCommissionOptions: [0, 2.5, 5, 10]
      },
      // we have to generate invoiceTemplateTypeFieldId dynamically because there can be multiple instances of FinanceInvoiceForm component on page and they should have different id's for invoice template type select field
      invoiceTemplateTypeFieldId: uniqueId('invoice-template-type-select-field-'),
      customFileChanged: false,
      customFilesAcceptedTypes: CUSTOM_FILE_ACCEPTED_TYPES.join(', '),
      ui: {
        // This flag turns `true` when Invoice edit form opens and document preview panel is already visible,
        // or when user toggles document preview panel visibility and appear animation is finished.
        // We don't want to render iframe before Doc Preview panel animation is finished, because then document does
        // not fit the iframe width.
        isDocPreviewIframeReadyToBeDisplayed: false
      }
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    isCustomTemplateTypeSelected () {
      return this.form.fields.invoice_template_type.value?.id === 6
    },
    uploadedCustomFileName () {
      return this.data?.custom_file_name
    },
    attachedCustomFileName () {
      return this.form.fields.custom_file.value?.name
    }
  },
  watch: {
    isLoading (newVal) {
      // When parent signals loading is done (e.g., after API error), sync internal loading state
      if (!newVal && this.internalLoading) {
        this.internalLoading = false
      }
    },
    'bankDetails': {
      deep: true,
      handler () {
        this.setBankDetails()
      }
    },
    'templates': {
      deep: true,
      handler () {
        this.setTemplates()
      }
    },
    'projects': {
      deep: true,
      handler () {
        this.setProjects()
      }
    },
    'statuses': {
      deep: true,
      handler () {
        this.setStatuses()
      }
    },
    'types': {
      deep: true,
      handler () {
        this.setInvoiceType()
      }
    },
    'data': {
      deep: true,
      handler () {
        this.setBasePreviewUrl(this.data?.preview_url ?? null)
      }
    },
    'form.fields.invoice_status': {
      deep: true,
      handler () {
        this.form.fields.paid_date.hidden = this.form.fields.invoice_status.value && this.form.fields.invoice_status.value.name !== 'paid'
        this.form.fields.paid_date.value = this.form.fields.paid_date.value ? this.form.fields.paid_date.value : this.form.fields.paid_date.defaultValue
      }
    },
    'form.fields.invoice_template_type': {
      deep: true,
      handler (invoiceTemplateType) {
        this.form.fields.custom_file.hidden = !(invoiceTemplateType.value && invoiceTemplateType.value.name === 'custom')
      }
    },
    'form.fields.client_bank_details': {
      deep: true,
      handler () {
        const selectedBank = this.clientsOptions.find(item =>
          this.form.fields.client_bank_details.value && item.id === this.form.fields.client_bank_details.value.id
        )
        if (selectedBank) {
          this.currency = selectedBank.currency.code
          this.calculateTotalAmount()
        }
      }
    },
    'form.fields.custom_file.value': {
      handler (cur) {
        if (cur) {
          this.customFileChanged = true
        }
      }
    },
    'form.fields.invoice_type.value': {
      deep: true,
      handler (newType, oldType) {
        // When switching to Employee Time and Material, ensure at least one item exists
        if (newType && newType.id === 1 && this.form.fields.items.value.length === 0) {
          this.form.fields.items.value = [{
            'user': null,
            'hours_amount': 0,
            'hour_cost': 0,
            'date_from': null,
            'date_to': null,
            'commission': null,
            'calculateHours': true,
            'hoursCalculating': false
          }]
        }
        // When switching to By project (Project Specialisation), ensure at least one specialisation exists
        if (newType && newType.id === 3 && this.form.fields.specialisations.value.length === 0) {
          this.form.fields.specialisations.value = [{
            'specialisation_id': null,
            'hours': null,
            'cost': null
          }]
        }
        // When switching to Only extra payments, ensure at least one extra payment exists
        if (newType && newType.id === 4 && this.form.fields.extra_payments.value.length === 0) {
          this.form.fields.extra_payments.value = [{
            'cost': 0,
            'description': '',
            'sales_commission_percent': 0
          }]
        }
      }
    },
    'value': {
      deep: true,
      handler () {
        if (this.value) {
          this.onShowInit()
        } else {
          this.onHideCleanUp()
        }
      }
    },
    formSubmissionAttempted (newValue) {
      // Track field errors when form submission is attempted
      if (newValue) {
        this.trackFieldErrors()
      }
    },
    backendErrors: {
      deep: true,
      handler (newErrors) {
        // Track backend errors
        if (newErrors && Object.keys(newErrors).length > 0) {
          this.trackFieldErrors()
        }
      }
    },
    show (newVal, oldVal) {
      if (newVal && !oldVal) {
        // Slideout is opening - start loading and record start time
        this.loadingStartTime = Date.now()
        this.isInitializing = true
        this.internalLoading = true
        this.$emit('loadingChange', true)

        // The existing mounted/watch logic will handle data fetching
        // Monitor for when loading should stop with proper timing
        setTimeout(() => {
          this.checkDataAndStopLoading()
        }, 100)

        // Set a timeout to end initialization phase after a reasonable time
        setTimeout(() => {
          if (this.isInitializing) {
            this.isInitializing = false
            // Check one more time if we should stop loading
            setTimeout(() => {
              this.checkDataAndStopLoading()
            }, 50)
          }
        }, 2000) // End initialization phase after 2 seconds max
      }
    }
  },
  mounted () {
    this.setInitialForm()
    if (this.data) {
      if (this.data.project) {
        this.changeProject(this.data.project)
      }
    }
  },
  methods: {
    ...mapActions({
      setIsModalLoading: 'finances/setIsModalLoading'
    }),
    checkDataAndStopLoading () {
      // Check if all required props are available
      const hasRequiredData =
        this.bankDetails && this.bankDetails.length > 0 &&
        this.projects && this.projects.length > 0 &&
        this.statuses && this.statuses.length > 0 &&
        this.types && this.types.length > 0 &&
        this.templates && this.templates.length > 0

      // Check if we're currently fetching project-specific data
      const isStillFetching = this.isFetchingBankDetails || this.isCalculatingAmount

      // During initialization, be more patient and wait for expected API calls
      const shouldKeepLoading = !hasRequiredData || isStillFetching || this.isInitializing

      if (!shouldKeepLoading) {
        // Check if minimum loading duration has passed
        const loadingElapsed = this.loadingStartTime ? Date.now() - this.loadingStartTime : 0
        const remainingTime = Math.max(0, this.minimumLoadingDuration - loadingElapsed)

        if (remainingTime > 0) {
          // Wait for minimum loading duration before stopping
          setTimeout(() => {
            this.isInitializing = false
            this.internalLoading = false
            this.$emit('loadingChange', false)
          }, remainingTime)
        } else {
          // Minimum duration has passed, stop immediately
          this.isInitializing = false
          this.internalLoading = false
          this.$emit('loadingChange', false)
        }
      } else {
        // If data is not available yet, check again after a short delay
        setTimeout(() => {
          this.checkDataAndStopLoading()
        }, 100)
      }
    },
    finishLoading () {
      // End any initialization phase
      this.isInitializing = false

      // Check if minimum loading duration has passed for form submissions
      const loadingElapsed = this.loadingStartTime ? Date.now() - this.loadingStartTime : 0
      const remainingTime = Math.max(0, this.minimumLoadingDuration - loadingElapsed)

      if (remainingTime > 0) {
        // Wait for minimum loading duration before stopping
        setTimeout(() => {
          this.internalLoading = false
          this.$emit('loadingChange', false)
        }, remainingTime)
      } else {
        // Minimum duration has passed, stop immediately
        this.internalLoading = false
        this.$emit('loadingChange', false)
      }
    },
    getBackendError (fieldName) {
      const error = this.backendErrors[fieldName]
      return error ? (Array.isArray(error) ? error[0] : error) : null
    },
    clearBackendError (fieldName) {
      if (this.backendErrors[fieldName]) {
        // Create a copy to trigger reactivity
        const updatedErrors = { ...this.backendErrors }
        delete updatedErrors[fieldName]
        this.backendErrors = updatedErrors
      }
    },
    clearRelatedDateErrors (changedField) {
      // When issue_date or due_date changes, clear both fields' backend errors since they're related
      const relatedDateFields = ['issue_date', 'due_date']
      let hasChanges = false
      const updatedErrors = { ...this.backendErrors }

      relatedDateFields.forEach(fieldName => {
        if (this.backendErrors[fieldName]) {
          delete updatedErrors[fieldName]
          hasChanges = true
        }
      })

      if (hasChanges) {
        this.backendErrors = updatedErrors
      }
    },
    clearAllBackendErrors () {
      // Clear all backend validation errors after successful submission
      this.backendErrors = {}
      this.fieldsWithPreviousErrors.clear() // Clear error tracking on form reset
    },
    shouldShowGreenBorder (fieldName) {
      // Only show green border if the field had errors before and is now valid
      const hasError = (this.formSubmissionAttempted && (this.$v.form.fields[fieldName]?.value?.$error || this.$v.form.fields[fieldName]?.value?.$invalid)) ||
                      this.getBackendError(this.getBackendFieldName(fieldName))
      const hadPreviousError = this.fieldsWithPreviousErrors.has(fieldName)
      const isDirty = this.$v.form.fields[fieldName]?.value?.$dirty

      return hadPreviousError && !hasError && isDirty && this.formSubmissionAttempted
    },
    getBackendFieldName (frontendFieldName) {
      // Convert frontend field names to backend field names for error checking
      const fieldMapping = {
        'project': 'project_id',
        'own_bank_details': 'own_bank_details_id',
        'client_bank_details': 'client_bank_details_id',
        'invoice_status': 'invoice_status_id',
        'invoice_template_type': 'invoice_template_type_id',
        'comment': 'comment',
        'comment_national': 'comment_national',
        'issue_date': 'issue_date',
        'due_date': 'due_date',
        'paid_date': 'paid_date'
      }
      return fieldMapping[frontendFieldName] || frontendFieldName
    },
    trackFieldErrors () {
      // Track which fields currently have errors
      const fieldNames = [
        'project', 'own_bank_details', 'client_bank_details', 'invoice_status',
        'invoice_template_type', 'comment', 'comment_national', 'issue_date', 'due_date', 'paid_date'
      ]

      fieldNames.forEach(fieldName => {
        const hasError = (this.formSubmissionAttempted && (this.$v.form.fields[fieldName]?.value?.$error || this.$v.form.fields[fieldName]?.value?.$invalid)) ||
                        this.getBackendError(this.getBackendFieldName(fieldName))

        if (hasError) {
          this.fieldsWithPreviousErrors.add(fieldName)
        }
      })
    },
    focusFirstErrorField () {
      // Wait for DOM updates to ensure error classes are applied
      this.$nextTick(() => {
        // Define the order of main form fields to check first
        const mainFieldOrder = [
          'project',
          'own_bank_details',
          'client_bank_details',
          'invoice_status',
          'invoice_template_type',
          'comment',
          'comment_national',
          'issue_date',
          'due_date'
        ]

        // Check main form fields first - prioritize these over table fields
        for (const fieldName of mainFieldOrder) {
          const field = this.$v.form.fields[fieldName]
          const hasError = field && field.value.$error

          if (hasError) {
            const focused = this.focusField(fieldName)
            if (focused) {
              return
            }
          }
        }

        // Only check employee items table if NO main form fields have errors
        let hasMainFormErrors = false
        for (const fieldName of mainFieldOrder) {
          if (this.$v.form.fields[fieldName] && this.$v.form.fields[fieldName].value.$error) {
            hasMainFormErrors = true
            break
          }
        }

        // If no main field errors, then check employee items table
        if (!hasMainFormErrors && this.$v.form.fields.items && this.$v.form.fields.items.value.$error) {
          const invalidEmployeeField = document.querySelector('.FinancesInvoicesCompanyItemsTable .is-invalid')
          if (invalidEmployeeField) {
            // Only scroll, don't focus to avoid UI disruption
            invalidEmployeeField.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }

        // If no main field errors, then check employee periods table
        if (!hasMainFormErrors && this.$v.form.fields.periods && this.$v.form.fields.periods.value.$error) {
          const invalidPeriodsField = document.querySelector('.FinancesInvoicesCompanyPeriodsTable .is-invalid')
          if (invalidPeriodsField) {
            // Only scroll, don't focus to avoid UI disruption
            invalidPeriodsField.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }

        // If no main field errors, then check specialisations table
        if (!hasMainFormErrors && this.$v.form.fields.specialisations && this.$v.form.fields.specialisations.value.$error) {
          const invalidSpecialisationsField = document.querySelector('.FinancesInvoicesCompanySpecialisationsTable .is-invalid')
          if (invalidSpecialisationsField) {
            // Only scroll, don't focus to avoid UI disruption
            invalidSpecialisationsField.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }
      })
    },
    getFieldSelectors (fieldName) {
      const selectorMap = {
        'project': [
          '.multiselect.is-invalid input',
          '.multiselect:has(.is-invalid) input',
          '.is-invalid .multiselect__input',
          '.multiselect__input'
        ],
        'own_bank_details': [
          '.multiselect.is-invalid input',
          '.is-invalid .multiselect__input',
          '.multiselect__input'
        ],
        'client_bank_details': [
          '.multiselect.is-invalid input',
          '.is-invalid .multiselect__input',
          '.multiselect__input'
        ],
        'invoice_status': [
          '.multiselect.is-invalid input',
          '.is-invalid .multiselect__input',
          '.multiselect__input'
        ],
        'invoice_template_type': [
          '.multiselect.is-invalid input',
          '.is-invalid .multiselect__input',
          '.multiselect__input'
        ],
        'comment': [
          'input.is-invalid',
          'input[type="text"].is-invalid'
        ],
        'comment_national': [
          'input.is-invalid',
          'input[type="text"].is-invalid'
        ],
        'issue_date': [
          '.vdp-datepicker.is-invalid input',
          '.datapicker input'
        ],
        'due_date': [
          '.vdp-datepicker.is-invalid input',
          '.datapicker input'
        ]
      }
      return selectorMap[fieldName] || []
    },
    focusField (fieldName) {
      // For multiselect fields, we need to find them by form structure
      if (['project', 'own_bank_details', 'client_bank_details', 'invoice_status', 'invoice_template_type'].includes(fieldName)) {
        // Find the form group containing the label text for this field
        const labels = document.querySelectorAll('.form__label')

        for (const label of labels) {
          const labelText = label.textContent.toLowerCase()
          let expectedText = ''

          switch (fieldName) {
            case 'project':
              expectedText = 'project'
              break
            case 'own_bank_details':
              expectedText = 'own bank details'
              break
            case 'client_bank_details':
              expectedText = 'client bank details'
              break
            case 'invoice_status':
              expectedText = 'invoice status'
              break
            case 'invoice_template_type':
              expectedText = 'invoice template type'
              break
          }

          if (labelText.includes(expectedText)) {
            // Find the multiselect in the same form group
            const formGroup = label.closest('.form-group') || label.closest('b-form-group')

            if (formGroup) {
              const multiselect = formGroup.querySelector('.multiselect')

              if (multiselect) {
                // Focus the input and scroll into view
                const input = multiselect.querySelector('input')
                if (input) {
                  input.focus()
                }
                multiselect.scrollIntoView({ behavior: 'smooth', block: 'center' })
                return true
              }
            }
          }
        }
      }

      // For regular input fields
      if (['comment', 'comment_national'].includes(fieldName)) {
        const input = document.querySelector(`input.is-invalid[type="text"]`)
        if (input) {
          input.focus()
          input.scrollIntoView({ behavior: 'smooth', block: 'center' })
          return true
        }
      }

      // For datepicker fields
      if (['issue_date', 'due_date'].includes(fieldName)) {
        const datepicker = document.querySelector('.vdp-datepicker.is-invalid input')
        if (datepicker) {
          datepicker.focus()
          datepicker.scrollIntoView({ behavior: 'smooth', block: 'center' })
          return true
        }
      }

      return false
    },
    scrollToField (fieldName) {
      // Scroll to field without focusing - for multiselect fields, we need to find them by form structure
      if (['project', 'own_bank_details', 'client_bank_details', 'invoice_status', 'invoice_template_type'].includes(fieldName)) {
        // Find the form group containing the label text for this field
        const labels = document.querySelectorAll('.form__label')

        for (const label of labels) {
          const labelText = label.textContent.toLowerCase()
          let expectedText = ''

          switch (fieldName) {
            case 'project':
              expectedText = 'project'
              break
            case 'own_bank_details':
              expectedText = 'own bank details'
              break
            case 'client_bank_details':
              expectedText = 'client bank details'
              break
            case 'invoice_status':
              expectedText = 'invoice status'
              break
            case 'invoice_template_type':
              expectedText = 'invoice template type'
              break
          }

          if (labelText.includes(expectedText)) {
            // Find the multiselect in the same form group
            const formGroup = label.closest('.form-group') || label.closest('b-form-group')

            if (formGroup) {
              const multiselect = formGroup.querySelector('.multiselect')

              if (multiselect) {
                // Only scroll into view, no focus
                multiselect.scrollIntoView({ behavior: 'smooth', block: 'center' })
                return true
              }
            }
          }
        }
      }

      // For regular input fields
      if (['comment', 'comment_national'].includes(fieldName)) {
        const input = document.querySelector(`input.is-invalid[type="text"]`)
        if (input) {
          input.scrollIntoView({ behavior: 'smooth', block: 'center' })
          return true
        }
      }

      // For datepicker fields
      if (['issue_date', 'due_date'].includes(fieldName)) {
        const datepicker = document.querySelector('.vdp-datepicker.is-invalid input')
        if (datepicker) {
          datepicker.scrollIntoView({ behavior: 'smooth', block: 'center' })
          return true
        }
      }

      return false
    },
    focusFirstErrorFieldFromBackend () {
      // Scroll to first field with backend errors without focusing, to avoid UI focus disruption
      this.$nextTick(() => {
        // Define the order of main form fields to check first
        const mainFieldOrder = [
          'project_id',
          'own_bank_details_id',
          'client_bank_details_id',
          'invoice_status_id',
          'invoice_template_type_id',
          'comment',
          'comment_national',
          'issue_date',
          'due_date'
        ]

        // Check main form fields first - prioritize these over table fields
        for (const fieldName of mainFieldOrder) {
          const hasBackendError = this.getBackendError(fieldName)

          if (hasBackendError) {
            // Convert backend field names to frontend field names for scrolling
            const frontendFieldName = this.convertBackendToFrontendFieldName(fieldName)
            const scrolled = this.scrollToField(frontendFieldName)
            if (scrolled) {
              return
            }
          }
        }

        // Check employee items table backend errors
        const employeeBackendErrors = Object.keys(this.backendErrors).filter(key => key.startsWith('items.'))
        if (employeeBackendErrors.length > 0) {
          const invalidEmployeeField = document.querySelector('.FinancesInvoicesCompanyItemsTable .is-invalid')
          if (invalidEmployeeField) {
            // Only scroll, don't focus
            invalidEmployeeField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            return
          }
        }

        // Check employee periods table backend errors
        const periodsBackendErrors = Object.keys(this.backendErrors).filter(key => key.startsWith('periods.'))
        if (periodsBackendErrors.length > 0) {
          const invalidPeriodsField = document.querySelector('.FinancesInvoicesCompanyPeriodsTable .is-invalid')
          if (invalidPeriodsField) {
            // Only scroll, don't focus
            invalidPeriodsField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            return
          }
        }

        // Check specialisations table backend errors
        const specialisationsBackendErrors = Object.keys(this.backendErrors).filter(key => key.startsWith('specialisations.'))
        if (specialisationsBackendErrors.length > 0) {
          const invalidSpecialisationsField = document.querySelector('.FinancesInvoicesCompanySpecialisationsTable .is-invalid')
          if (invalidSpecialisationsField) {
            // Only scroll, don't focus
            invalidSpecialisationsField.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }
      })
    },
    convertBackendToFrontendFieldName (backendFieldName) {
      // Convert backend field names (with _id suffix) to frontend field names
      const conversionMap = {
        'project_id': 'project',
        'own_bank_details_id': 'own_bank_details',
        'client_bank_details_id': 'client_bank_details',
        'invoice_status_id': 'invoice_status',
        'invoice_template_type_id': 'invoice_template_type',
        'comment': 'comment',
        'comment_national': 'comment_national',
        'issue_date': 'issue_date',
        'due_date': 'due_date'
      }
      return conversionMap[backendFieldName] || backendFieldName
    },
    isEmployeeTm (invoiceTypeId = null) {
      if (!invoiceTypeId && this.form.fields.invoice_type.value) {
        invoiceTypeId = this.form.fields.invoice_type.value.id
      }
      return invoiceTypeId === this.config.invoiceTypes.employee_tm.id
    },
    isEmployeePeriod (invoiceTypeId = null) {
      if (!invoiceTypeId && this.form.fields.invoice_type.value) {
        invoiceTypeId = this.form.fields.invoice_type.value.id
      }
      return invoiceTypeId === this.config.invoiceTypes.employee_period.id
    },
    cachePreview (selectedOption, id) {
      if (this.mode === 'create') {
        return
      }

      if (id !== this.invoiceTemplateTypeFieldId && this.form.fields.invoice_template_type.value.id === 6) {
        // Do not update document preview when 'custom' (id === 6) invoice template type is selected, unless user changes the invoice_template_type field itself.
        // We don't need to update document preview for 'custom' invoice template type, since for this type users upload file themselves, and it's not generated on the server.
        return
      }

      this.updatePreviewRequestScheduled = true
      this.cachePreviewDebounced()
    },
    cachePreviewDebounced: debounce(function () {
      const data = this.prepareDataForEditAndCreateRequest(this.form.fields)
      this.updateDocPreview(data)
    }, 2000),
    updateDocPreview (docData) {
      // Override the mixin's updateDocPreview to add backend validation error handling
      docData['preview'] = true
      this.isLastUpdatePreviewRequestFailed = false

      if (this.updateRequestCancelToken) {
        this.updateRequestCancelToken.cancel('Obsolete "document preview update" request canceled')
      }
      this.updateRequestCancelToken = this.axios.CancelToken.source()

      const docPreviewVersion = this.docPreviewVersion + 1
      const updatePreviewCacheUrl = '/api/finances/invoices/cache-preview/'

      this.axios
        .post(updatePreviewCacheUrl + docPreviewVersion, docData, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          },
          cancelToken: this.updateRequestCancelToken.token
        })
        .then(() => {
          this.docPreviewVersion = docPreviewVersion
        })
        .catch(err => {
          if (this.axios.isCancel(err)) {
            return
          }

          console.error(err)
          this.isLastUpdatePreviewRequestFailed = true

          // Handle backend validation errors from cache-preview request
          if (err.response?.data?.errors) {
            // Set backend validation errors for form display
            this.backendErrors = { ...this.backendErrors, ...err.response.data.errors }
            this.focusFirstErrorFieldFromBackend()

            // Show single validation message instead of listing all errors
            this.$snotify.error(
              'The form is not valid. Please fill all required fields with valid data.',
              'Validation Error',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.updatePreviewRequestScheduled = false
        })
    },
    setInitialForm () {
      this.setAllOptions()
    },
    resetForm () {
      this.form = cloneDeep(this.defaultForm)
      this.setInitialForm()
    },
    onShowInit () {
      this.customFileChanged = false // reset this flag
      this.ui.isDocPreviewIframeReadyToBeDisplayed = this.isDocumentPreviewPanelVisible
      this.resetDocumentPreview()
      // There are multiple instances of the FinanceInvoicesForm components and they should synchronize they `isDocumentPreviewPanelVisible`.
      // That's why we need to read document preview visibility state from localStorage and set it to the component's state.
      this.restoreDocumentPreviewVisibilityStateFromLS()

      if (this.data) {
        this.setParamsForEditInvoiceForm(this.data)
        if (!this.form.fields.project.value || this.form.fields.project.value.id !== this.data.project.id) {
          this.changeProject(this.data.project)
        }
      }
    },
    onHideCleanUp () {
      this.$v.$reset()
      this.resetForm()
      this.formSubmissionAttempted = false
      this.ui.isDocPreviewIframeReadyToBeDisplayed = false
      this.isCalculatingAmount = false
      if (this.calculateTotalCancelToken) {
        this.calculateTotalCancelToken.cancel('Cancel request')
      }
    },
    setAllOptions () {
      this.setBankDetails()
      this.setClientsBankDetails()
      this.setTemplates()
      this.setProjects()
      this.setStatuses()
      this.setInvoiceType()
      this.form.fields.comment.value = this.form.fields.comment.defaultValue
      this.form.fields.comment_national.value = this.form.fields.comment_national.defaultValue
      this.config.matchProjectName = this.config.defaultProjectName
      this.form.fields.custom_file.value = null
    },
    setBankDetails () {
      this.form.fields.own_bank_details.options = this.bankDetails
    },
    setClientsBankDetails () {
      this.form.fields.client_bank_details.options = this.clientsOptions
      this.form.fields.client_bank_details.disabled = !this.clientsOptions.length
    },
    setTemplates () {
      this.form.fields.invoice_template_type.options = this.templates
      if (!this.form.fields.invoice_template_type.value) {
        this.form.fields.invoice_template_type.value = this.templates.find(el => el.name === 'giraffesoftware')
      }
    },
    setProjects () {
      this.form.fields.project.options = this.projects
    },
    setStatuses () {
      this.form.fields.invoice_status.options = this.statuses
      if (!this.form.fields.invoice_status.value) {
        this.form.fields.invoice_status.value = this.statuses.find(el => el.name === 'paid')
      }
    },
    setInvoiceType () {
      this.form.fields.invoice_type.options = this.types
      if (!this.form.fields.invoice_type || !this.form.fields.invoice_type.value) {
        this.form.fields.invoice_type.value = this.types.find(el => el.type === 'Employee time and material')

        // Ensure items array has one default item for Employee Time and Material
        if (this.form.fields.invoice_type.value && this.form.fields.invoice_type.value.id === 1) {
          if (this.form.fields.items.value.length === 0) {
            this.form.fields.items.value = [{
              'user': null,
              'hours_amount': 0,
              'hour_cost': 0,
              'date_from': null,
              'date_to': null,
              'commission': null,
              'calculateHours': true,
              'hoursCalculating': false
            }]
          }
        }
      }
    },
    async setParamsForEditInvoiceForm (invoiceData) {
      const newParams = cloneDeep(invoiceData)

      if (this.isEmployeeTm()) {
        newParams.items = this.prepareItems(invoiceData['items'])
      } else if (this.isEmployeePeriod()) {
        newParams.periods = this.prepareItems(invoiceData['periods'])
      }

      for (let key in this.form.fields) {
        if (key === 'auto_fill' && !newParams['auto_fill']) {
          newParams['auto_fill'] = cloneDeep(this.form.fields.auto_fill.defaultValue)
        }
        this.form.fields[key]['value'] = newParams[key]
      }
      if (invoiceData.client_bank_details && invoiceData.client_bank_details.currency.code) {
        this.currency = invoiceData.client_bank_details.currency.code
        this.fetchClientBanks(this.form.fields.project.value.id)
      }
      this.form.fields.amount.value = invoiceData.total_amount
      this.form.fields.custom_file.value = null
    },
    prepareItems (items) {
      return items ? items.map(item => {
        return {
          ...item,
          // user is null for the empty placeholder row (no previous invoice / nothing to auto fill)
          'user_id': item.user ? item.user.id : null,
          'calculateHours': true,
          'hoursCalculating': false
        }
      }) : []
    },
    mergeWithPreviousCommissions (items, previousItems) {
      // previous invoice may be absent and rows without user are placeholders, so both are skipped
      const commissions = (previousItems || []).reduce((obj, item) => {
        return item.user ? {
          ...obj,
          [item['user']['id']]: item['commission']
        } : obj
      }, {})

      items = items.map(item => {
        if (item.user && commissions[item.user.id]) {
          item['commission'] = commissions[item.user.id]
        }
        return item
      })

      return items
    },
    async submit (data) {
      this.formSubmissionAttempted = true
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.trackFieldErrors() // Track which fields have errors
        this.focusFirstErrorField()
        return
      }

      if (await this.validateFields(data)) {
        this.loadingStartTime = Date.now()
        this.internalLoading = true
        this.$emit('loadingChange', true)

        if (this.$refs['customFile'] && this.$refs['customFile'].value) {
          const customFileBase64 = await this.fileToBase64(this.$refs['customFile'].value)
          data.custom_file.value = customFileBase64
        } else {
          data.custom_file.value = null
        }
        this.$emit('submit', data)
      }
    },
    async submitForm () {
      this.submit(cloneDeep(this.form.fields))
    },
    async fetchClientBanks (id) {
      this.isFetchingBankDetails = true

      try {
        const clientsBanksResponse = await this.$api.finances.getClientsBankDetailsByProject(id)
        if (clientsBanksResponse.data) {
          this.clientsOptions = clientsBanksResponse.data
          this.setClientsBankDetails()
          return clientsBanksResponse.data
        }
        return null
      } finally {
        this.isFetchingBankDetails = false
      }
    },
    async refreshClientBanks () {
      if (this.form.fields.project.value.id) {
        this.isFetchingBankDetails = true
        await this.fetchClientBanks(this.form.fields.project.value.id)
        this.isFetchingBankDetails = false
      }
    },
    calculateTotalAmount: debounce(function () {
      this.calculateTotalAmountRequest()
    }, 1500),
    async calculateTotalAmountRequest () {
      const parameters = this.prepareParametersForCalculateAmount()
      const invoiceType = this.form.fields.invoice_type.value.id
      if (
        (this.isEmployeeTm() && parameters.items.length === 0) ||
        (this.isEmployeePeriod() && parameters.periods.length === 0) ||
        (invoiceType === this.config.invoiceTypes.project_specialisation.id && parameters.specialisations.length === 0) ||
        (invoiceType === this.config.invoiceTypes.employee_only_extra_payments.id && parameters.extra_payments.length === 0)
      ) {
        return
      }

      if (this.calculateTotalCancelToken) {
        this.calculateTotalCancelToken.cancel()
      }
      this.calculateTotalCancelToken = this.axios.CancelToken.source()

      this.isCalculatingAmount = true

      this.$api.finances.calculateTotalAmount(parameters, {
        cancelToken: this.calculateTotalCancelToken.token
      })
        .then((res) => {
          if (res.data && !isNaN(res.data.totalAmount)) {
            this.form.fields.amount.value = res.data.totalAmount
          }
        }).catch((error) => {
          // Handle backend validation errors from calculate total amount request
          if (error?.response?.data?.errors) {
            this.backendErrors = { ...this.backendErrors, ...error.response.data.errors }
            this.focusFirstErrorFieldFromBackend()

            // Show single validation message instead of detailed errors
            this.$snotify.error(
              'The form is not valid. Please fill all required fields with valid data.',
              'Validation Error',
              this.$store.state.snotify
            )
          } else {
            // Only call outputErrorNotification for non-validation errors
            this.outputErrorNotification(error)
          }
        }).finally(() => {
          this.isCalculatingAmount = false
          // Trigger loading check after calculation completes
          setTimeout(() => {
            this.checkDataAndStopLoading()
          }, 50)
        })
    },
    prepareParametersForCalculateAmount () {
      const extraPayments = this.form.fields.extra_payments.value.map(extraPayment => {
        return { cost: extraPayment.cost }
      }).filter(extraPayment => {
        return extraPayment.cost
      })
      let data = {
        client_bank_details_id: this.form.fields.client_bank_details.value ? this.form.fields.client_bank_details.value.id : null,
        invoice_type_id: this.form.fields.invoice_type.value.id,
        commission: this.form.fields.commission.value,
        extra_payments: extraPayments,
        items: [],
        periods: [],
        specialisations: []
      }
      if (this.isEmployeeTm()) {
        data.items = this.form.fields.items.value.map(item => {
          return {
            hours_amount: item.hours_amount,
            hour_cost: item.hour_cost,
            commission: item.commission
          }
        }).filter(item => {
          return item.hours_amount && item.hours_amount > 0 && item.hour_cost && item.hour_cost > 0
        })
      }
      if (this.form.fields.invoice_type.value.id === this.config.invoiceTypes.employee_period.id) {
        data.periods = this.form.fields.periods.value.map(period => {
          return {
            period_cost: period.period_cost,
            commission: period.commission
          }
        }).filter(period => {
          return period.period_cost && period.period_cost > 0
        })
      }
      if (this.form.fields.invoice_type.value.id === this.config.invoiceTypes.project_specialisation.id) {
        data.specialisations = this.form.fields.specialisations.value.map(specialisation => {
          return {
            cost: specialisation.cost
          }
        }).filter(specialisation => {
          return specialisation.cost && specialisation.cost > 0
        })
      }
      return data
    },
    async fetchPreviousProjectInvoice (projectId) {
      return this.axios.get('/api/finances/invoices/last-project-invoice/' + projectId,
        { headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        } })
    },
    fetchUserInvoiceHours (userId, projectId, type, dateFrom, dateTo, invoiceId) {
      return this.axios.get('/api/working-time/working-hours-for-invoices', {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        },
        params: {
          type,
          user_id: userId,
          project_id: projectId,
          date_from: dateFrom,
          date_to: dateTo,
          invoice_id: invoiceId
        }
      })
    },
    async changeProject (project) {
      this.form.fields.project.value = project

      await this.fetchClientBanks(project.id)

      if (this.mode === 'create') {
        this.setIsModalLoading(true)
        const lastProjectInvoiceData = await this.fillWithLastProjectInvoiceData(project.id)
        this.setIsModalLoading(false)
        if ((this.isEmployeeTm() || this.isEmployeePeriod()) && !this.form.fields.invoice_type.touched) {
          await this.autoFill()
        } else {
          // Reset to one empty employee item for Employee Time and Material
          if (this.isEmployeeTm()) {
            this.form.fields.items.value = [{
              'user': null,
              'hours_amount': 0,
              'hour_cost': 0,
              'date_from': null,
              'date_to': null,
              'commission': null,
              'calculateHours': true,
              'hoursCalculating': false
            }]
          } else {
            this.form.fields.items.value = []
          }

          if (!this.isEmployeePeriod()) {
            this.form.fields.periods.value = []
          }

          // Reset to one empty specialisation item for By project (Project Specialisation)
          if (this.form.fields.invoice_type.value && this.form.fields.invoice_type.value.id === 3) {
            this.form.fields.specialisations.value = [{
              'specialisation_id': null,
              'hours': null,
              'cost': null
            }]
          } else {
            this.form.fields.specialisations.value = []
          }
        }
        if (Object.keys(lastProjectInvoiceData).length === 0) {
          this.form.fields.comment.value = this.form.fields.comment.defaultValue
          this.form.fields.comment_national.value = this.form.fields.comment_national.defaultValue
          this.config.matchProjectName = this.config.defaultProjectName
        }
        await this.replaceCommentsWithProjectName()
      }

      // Trigger loading check after project change is complete
      setTimeout(() => {
        this.checkDataAndStopLoading()
      }, 100)
    },
    async replaceCommentsWithProjectName () {
      const project = this.form.fields.project.value

      const regExp = new RegExp(this.config.matchProjectName.replace('[', '').replace(']', ''), 'g')
      if (project && project.name) {
        this.config.matchProjectName = project.name

        if (this.form.fields.comment.value.match(regExp)) {
          this.form.fields.comment.value = this.form.fields.comment.value.replace(regExp, project.name.replace('[', '').replace(']', ''))
        }

        if (this.form.fields.comment_national.value.match(regExp)) {
          this.form.fields.comment_national.value = this.form.fields.comment_national.value.replace(regExp, project.name.replace('[', '').replace(']', ''))
        }
      }
    },
    async fillWithLastProjectInvoiceData (projectId) {
      const response = await this.fetchPreviousProjectInvoice(projectId)
      if (Object.keys(response.data).length > 0) {
        this.form.fields.own_bank_details.value = !this.form.fields.own_bank_details.touched ? response.data.own_bank_details : this.form.fields.own_bank_details.value
        this.form.fields.client_bank_details.value = response.data.client_bank_details ? response.data.client_bank_details : null
        this.form.fields.invoice_template_type.value = !this.form.fields.invoice_template_type.touched ? response.data.invoice_template_type : this.form.fields.invoice_template_type.value
        this.form.fields.comment.value = response.data.comment ? response.data.comment : null
        this.form.fields.comment_national.value = response.data.comment_national ? response.data.comment_national : null

        if (!this.form.fields.invoice_type.touched) {
          this.previousInvoiceData.items = response.data.items
          this.previousInvoiceData.periods = response.data.periods
          this.form.fields.specialisations.value = response.data.specialisations
          this.form.fields.extra_payments.value = response.data.extra_payments
          this.form.fields.commission.value = response.data.commission ? response.data.commission : null
          this.form.fields.invoice_type.value = response.data.invoice_type
        }
      }
      return response.data
    },
    handleAutoFillButtonClick () {
      this.autoFill(true)
    },
    /**
     * @param isMarkDirty {boolean} specifies if fields updated in the result of this method call should be marked as dirty
     */
    async autoFill (isMarkDirty) {
      const projectId = this.form.fields.project.value.id
      const invoiceTypeId = this.form.fields.invoice_type.value.id
      const dateFrom = this._toLocalTime(this.form.fields.auto_fill.value.date_from)
      const dateTo = this._toLocalTime(this.form.fields.auto_fill.value.date_to)
      const invoiceId = this.form.fields.id.value

      if (!dateFrom || !dateTo) {
        this.$snotify.info(
          'Please select time interval: "date from" - "date to" ',
          'Info',
          this.$store.state.snotify
        )
        return
      }

      this.setIsModalLoading(true)

      await this.autoFillRequest({
        project_id: projectId, invoice_type_id: invoiceTypeId, date_from: dateFrom, date_to: dateTo, invoice_id: invoiceId
      }, isMarkDirty)

      this.calculateTotalAmount()

      this.setIsModalLoading(false)
    },
    /**
     * @param data {Object} input data
     * @param isMarkDirty {boolean} specifies if fields updated in the result of this method call should be marked as dirty
     */
    async autoFillRequest (data, isMarkDirty) {
      try {
        const autoFillResponse = await this.axios.post(
          `/api/finances/invoices/auto-fill-request`,
          data,
          { headers: { Authorization: 'Bearer' + localStorage.getItem('access_token') } })

        if (autoFillResponse.data) {
          const autoFillItems = autoFillResponse.data

          if (this.isEmployeeTm()) {
            const items = this.prepareItems(autoFillItems)
            this.form.fields.items.value = this.mergeWithPreviousCommissions(items, this.previousInvoiceData.items)
            if (isMarkDirty) this.$v.form.fields.items.value.$touch()
          } else if (this.isEmployeePeriod()) {
            const periods = this.prepareItems(autoFillItems)
            this.form.fields.periods.value = this.mergeWithPreviousCommissions(periods, this.previousInvoiceData.periods)
            if (isMarkDirty) this.$v.form.fields.periods.value.$touch()
          }
          return autoFillItems
        } else {
          // If no autofill data, reset to one empty employee item for Employee Time and Material
          if (this.isEmployeeTm()) {
            this.form.fields.items.value = [{
              'user': null,
              'hours_amount': 0,
              'hour_cost': 0,
              'date_from': null,
              'date_to': null,
              'commission': null,
              'calculateHours': true,
              'hoursCalculating': false
            }]
          } else {
            this.form.fields.items.value = []
          }

          if (!this.isEmployeePeriod()) {
            this.form.fields.periods.value = []
          }

          if (isMarkDirty) {
            this.$v.form.fields.items.value.$touch()
            this.$v.form.fields.periods.value.$touch()
          }
        }
      } catch (error) {
        this.errorNotifications(error)
      }
      return []
    },
    dataTouched ({ index, attrName, attrValue }, itemType) {
      this.form.fields.invoice_type.touched = true
      if (attrName === 'auto_hours_amount' && itemType) {
        this.form.fields[itemType].value[index].calculateHours = attrValue
        if (attrValue) {
          this.calculateHours(index, itemType)
        }
      } else if ((attrName === 'date_from' || attrName === 'date_to' || attrName === 'user') && itemType && this.form.fields[itemType].value[index].calculateHours) {
        this.calculateHours(index, itemType)
      }
      if (this.needInvoiceAmountRecalculate(itemType, attrName)) {
        this.calculateTotalAmount()
      }
      this.cachePreview()
    },
    dataRemoved ({ index }, itemType) {
      if (this.config.requireRecalculateInvoiceAmount[itemType]) {
        this.calculateTotalAmount()
      }
    },
    needInvoiceAmountRecalculate (itemType, attrName) {
      if (!this.config.requireRecalculateInvoiceAmount[itemType]) {
        return false
      }
      if (this.config.requireRecalculateInvoiceAmount[itemType] === true) {
        return true
      }
      if (Array.isArray(this.config.requireRecalculateInvoiceAmount[itemType])) {
        return this.config.requireRecalculateInvoiceAmount[itemType].includes(attrName)
      }
    },
    calculateHours (index, type) {
      const item = this.form.fields[type].value[index]
      if (item.user && item.date_from && item.date_to) {
        this.form.fields[type].value[index].hoursCalculating = true
        this.fetchUserInvoiceHours(
          item.user.id,
          this.form.fields.project.value.id,
          type,
          this._toLocalTime(item.date_from),
          this._toLocalTime(item.date_to),
          this.form.fields.id?.value
        )
          .then(response => {
            this.form.fields[type].value[index].hours_amount = response.data.hours_amount
            this.form.fields[type].value[index].hours_amount_logged = response.data.hours_amount_logged
            this.form.fields[type].value[index].hours_amount_time_offs = response.data.hours_amount_time_offs
            this.form.fields[type].value[index].hours_amount_planned = response.data.hours_amount_planned
            this.form.fields[type].value[index].hoursCalculating = false
            this.calculateTotalAmount()
          })
          .catch(err => {
            this.form.fields[type].value[index].hoursCalculating = false
            console.error(err)
            // Handle backend validation errors from working hours request
            if (err?.response?.data?.errors) {
              this.backendErrors = { ...this.backendErrors, ...err.response.data.errors }
              this.focusFirstErrorFieldFromBackend()

              // Show single validation message instead of detailed errors
              this.$snotify.error(
                'The form is not valid. Please fill all required fields with valid data.',
                'Validation Error',
                this.$store.state.snotify
              )
            }
          })
      }
    },
    updateItem (itemName, fieldData) {
      this.$emit('updateItem', itemName, fieldData)
    },
    keyDown (event) {
      if (event.key === 'Enter') {
        event.preventDefault()
        this.submit()
      }
    },
    async closeForm () {
      if (this.$v.form.fields.$anyDirty) {
        const confirm = await this.$root.$confirm.open(
          'Data not saved',
          'Are you sure you want to close without saving?',
          { submitText: 'Close' }
        )
        if (!confirm) return
      }
      // Clear backend errors when closing form
      this.clearAllBackendErrors()
      this.show = false
      this.$emit('invoiceFormClosed')
    },
    toggleMainBlock (event) {
      event.preventDefault()
      this.blocksShow.main = !this.blocksShow.main
    },
    toggleItemsBlock (event) {
      event.preventDefault()
      this.blocksShow.items = !this.blocksShow.items
    },
    showDownloadModal () {
      // Create an enhanced data object with current form values
      const currentInvoiceData = {
        ...this.data,
        // Override with current form value for template type
        invoice_template_type: this.form.fields.invoice_template_type.value
      }

      // Get the trigger element
      const triggerElement = this.$refs.downloadButton?.$el || null

      this.$emit('showDownloadModal', {
        invoice: currentInvoiceData,
        triggerElement
      })
    },
    formatDate (date) {
      if (!date) return ''
      return Moment(date).format('DD.MM.YYYY')
    },
    isInvoiceOverdue (invoice) {
      if (!invoice.due_date || !invoice.invoice_status) {
        return false
      }

      const isPaid = invoice.invoice_status.name === 'paid'
      if (isPaid) {
        return false
      }

      const today = new Date()
      const dueDate = new Date(invoice.due_date)
      today.setHours(0, 0, 0, 0)
      dueDate.setHours(0, 0, 0, 0)

      return dueDate < today
    },
    getOverdueDays (invoice) {
      if (!invoice.due_date) return 0

      const today = new Date()
      const dueDate = new Date(invoice.due_date)
      today.setHours(0, 0, 0, 0)
      dueDate.setHours(0, 0, 0, 0)

      const diffTime = today - dueDate
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

      return diffDays > 0 ? diffDays : 0
    }
  }
}
</script>

<style lang="scss" scoped>
.loader {
  background-color: rgba($bgColorBase, 0.7);
}

.row {
  margin-right: -7px;
  margin-left: -7px;
}

.form-generator .row:last-child .form-group {
  margin-bottom: 0;
}

.material-symbols-outlined.text-danger {
  color: #dc3545 !important;
}
</style>

<style lang="scss" scoped>
.column-header-class {
  font-size: 12px;
  font-weight: normal;
  font-family: "Ubuntu", sans-serif;
  color: #8094B2;
}
</style>
